import { render } from "./DVCommandDropdown.vue?vue&type=template&id=7b74b3ba"
import script from "./DVCommandDropdown.vue?vue&type=script&lang=js"
export * from "./DVCommandDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__